import { Sparkles } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { TravelUpsellRoutes } from "./routes";
import { TravelUpsellPermissions } from "./permissions";

export const travelUpsellNav: INavItem = {
  labelKey: "nav.upsells",
  icon: Sparkles,
  path: TravelUpsellRoutes.LIST,
  permissions: [TravelUpsellPermissions.READ],
  permissionPrefix: "Travel:Upsells:",
  children: [
    {
      labelKey: "nav.upsells_manage",
      path: TravelUpsellRoutes.LIST,
      permissions: [TravelUpsellPermissions.READ],
    },
    {
      labelKey: "nav.upsell_destinations",
      path: TravelUpsellRoutes.DESTINATIONS,
      permissions: [TravelUpsellPermissions.READ],
    },
  ],
};
